import { LicenseList } from "./model";

export enum NameStatusLicense {
    NOT_ACTIVATED = "Not Activated",
    ACTIVATED = "Activated",
    EXPIRED = "Expired",
    DEACTIVATED = "Deactivated",
    GRACE_PERIOD = "Grace period",
}

export enum StatusMaskLicense {
    NONE = 0,
    NOT_ACTIVATED = 1,
    ACTIVATED = 2,
    EXPIRED = 4,
    DEACTIVATED = 8,
    GRACE_PERIOD = 16,
}

export enum TypeMaskLicense {
    LIFETIME = 0,
    SUBSCRIPTION = 1,
}

export type ColorStatus = "green" | "yellow" | "red" | "blue" | "grey";
export type MaskStatus = 0 | 1 | 2 | 4 | 8 | 16; // TODO: get StatusMaskLicense value

export type LicenseStatusParam = {
    status: MaskStatus;
    name: `${NameStatusLicense}`;
    color: ColorStatus;
};

type LicenseStatus = {
    [key in NameStatusLicense]: LicenseStatusParam;
};

export const licenseStatus: LicenseStatus = {
    "Not Activated": {
        status: StatusMaskLicense.NOT_ACTIVATED,
        name: NameStatusLicense.NOT_ACTIVATED,
        color: "red",
    },
    Activated: {
        status: StatusMaskLicense.ACTIVATED,
        name: NameStatusLicense.ACTIVATED,
        color: "green",
    },
    Expired: {
        status: StatusMaskLicense.EXPIRED,
        name: NameStatusLicense.EXPIRED,
        color: "yellow",
    },
    Deactivated: {
        status: StatusMaskLicense.DEACTIVATED,
        name: NameStatusLicense.DEACTIVATED,
        color: "blue",
    },
    "Grace period": {
        status: StatusMaskLicense.GRACE_PERIOD,
        name: NameStatusLicense.GRACE_PERIOD,
        color: "grey",
    },
} as const;

type LicenseStatusKey = keyof typeof licenseStatus;

export interface ILicenseStatus {
    name: string;
    color: string;
}

export function getStatusData(status: number): ILicenseStatus {
    const statusKeys = Object.keys(licenseStatus) as LicenseStatusKey[];
    const foundKey = statusKeys.find((key) => {
        return licenseStatus[key].status === Number(status);
    }) as LicenseStatusKey;

    return {
        name: licenseStatus[foundKey]?.name,
        color: licenseStatus[foundKey]?.color,
    };
}

export function getAllIdLicenses(list: LicenseList): number[] {
    const licenseKeys: number[] = [];

    list.forEach((el) => {
        if (el.license.status !== licenseStatus.Activated.status) {
            licenseKeys.push(el.license.id);
        }
    });

    return licenseKeys;
}

export function detectCurrentNameStatus(
    statusMask: number,
    statusName: string | Array<string>,
): boolean {
    return Array.isArray(statusName)
        ? statusName.includes(getStatusData(statusMask)?.name)
        : getStatusData(statusMask)?.name === statusName;
}
